import { useAuthState } from '@percent/cause-dashboard/common/hooks'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import type { CausesPortalOpportunityDto } from '@percent/cause-dashboard/services/volunteering/volunteeringService.types'
import { useQuery } from '@percent/utility'

export type UseCanManageOpportunityProps = Readonly<{
  opportunity: CausesPortalOpportunityDto
}>

export const useCanManageOpportunity = ({ opportunity }: UseCanManageOpportunityProps): boolean => {
  const { volunteeringService } = useServices()
  const { authState } = useAuthState()
  const organisationId = authState.user?.organisationId

  const { data: volunteeringPartners } = useQuery(
    ['volunteering-partners'],
    volunteeringService.getVolunteeringPartners,
    {},
    { enabled: !!organisationId }
  )

  return !!volunteeringPartners?.some(partner => partner.id === opportunity.partner.id)
}
